module.exports = __webpack_public_path__ + "img/callOnline.35594d7c.png";